import { useState, useEffect, useCallback } from 'react';
import client from '../../api/client';
import CalendarView from '../components/CalendarView';
import { NAVY } from '../../styles/tokens';

export default function AdminCalendarPage() {
  const [events, setEvents] = useState([]);
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear]   = useState(new Date().getFullYear());

  const fetchCalendar = useCallback((m, y) => {
    client.get('/api/vacation/calendar', { params: { month: m + 1, year: y } })
      .then(r => setEvents(r.data))
      .catch(console.error);
  }, []);

  useEffect(() => { fetchCalendar(month, year); }, [month, year, fetchCalendar]);

  return (
    <div className="page-pad" style={{ padding: '20px 24px', maxWidth: 800, margin: '0 auto' }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, color: NAVY, margin: '0 0 16px' }}>Calendario de Equipo</h1>

      {/* ⚰ V65 — TARJETAS DE RESUMEN (Pendientes / Aprobadas) RETIRADAS.
          Duplicaban la fila de estados que ahora está arriba, en la misma pestaña, y
          peor: contaban OTRA COSA. Estas sumaban EVENTOS DEL MES visible y la fila de
          arriba cuenta SOLICITUDES DEL AÑO en el alcance del usuario, así que los dos
          números se veían comparables y nunca coincidían — exactamente la clase de
          desajuste que hace desconfiar de la pantalla entera.
          El calendario se queda con el calendario. */}

      <CalendarView
        events={events}
        month={month}
        year={year}
        onMonthChange={(m, y) => { setMonth(m); setYear(y); }}
      />
    </div>
  );
}
